import Typed from "typed.js";

var options = {
    strings: [
        "Cerca su Frav.it",
        "Cerca la tua Audi",
        "Cerca la tua Porsche",
        "Cerca Audi usate",
        "Cerca Audi nuove",
        "Cerca Audi km 0",
        "Cerca Sportback",
    ],
    typeSpeed: 90,
    backSpeed: 60,
    attr: "placeholder",
    smartBackspace: true,
    bindInputFocusEvents: true,
    loop: true,
};

var typedDesktop = document.getElementById("searchtext");
// var typedMobile = document.getElementById("searchtextmobile");

if (typedDesktop) {
    var typed = new Typed(typedDesktop, options);
    typedDesktop.addEventListener('focus', function() {
        typed.destroy();
        this.placeholder = '';
    });
}
// if (typedMobile) {
//     var typed_mobile = new Typed(typedMobile, options);
// }
